import GeneralInfomation from '@/views/GeneralInfomation/index.vue'

const GeneralInfomationRouter = {
  path: '/infomation',
  name: 'GeneralInfomation',
  component: GeneralInfomation,
  props: (route) => ({
    secret: route.query.secret,
    token: route.query.token
  })
}

export default GeneralInfomationRouter
